exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-component[data-v-97880ee2] {\n  min-height: 0px;\n}\n", ""]);

// exports
